import photos from "../../../assets/images/photos.png";
import consent from "../../../assets/images/consent.png";
import styles from "./Info.module.scss";
import { PrimaryButton } from "../../UI/PrimaryButton/PrimaryButton";
//import star from "../../../assets/images/star.svg";

export const Info = ({ onGetStarted }) => {
  const signNowHandler = () => {
    window.location.href = `${process.env.REACT_APP_URL}/patient-consent-form`;
  };

  return (
    <div className={styles.root}>
      <hr />

      <h1 className="mt-6 ignore-stroke">What you need</h1>
      <h3 className="mb-2">Photos from operation</h3>
      <img src={photos} alt="Step-by-step photos" />

      <h3 className="mt-7 mb-2">Signed consent form</h3>
      <p>The patient give consent to use photos from their operation</p>
      <img
        src={consent}
        className={styles.consentImage}
        alt="A consent document"
      />
      <div className="mt-3 mb-5">
        <PrimaryButton onClick={signNowHandler}>
          Sign patient consent form now
        </PrimaryButton>
      </div>

      <hr />
      <PrimaryButton onClick={onGetStarted} block className="mt-3">
        Upload your case
      </PrimaryButton>
    </div>
  );
};
